export default "__VITE_ASSET__CRPps68T__"